module.exports = __webpack_public_path__ + "img/ICON_PLAY_NOW.e08e5424.png";